import moment from 'moment';
import H_time from "@/helpers/time";

export default {
  modelName: 'announcement',
  label: '新訊',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    alliance: {
      type: 'belongsTo',
      label: '聯盟',
      rules: 'required',
      textKey: 'name',
      modelName: 'alliance',
      clearable: true,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '標題',
          rules: 'required',
          maxlength: 100,
        },
        introduction: {
          type: 'textarea',
          label: '簡介',
          rules: 'required',
          maxlength: 1000,
        },
        content: {
          type: 'editor',
          label: '內容',
          rules: 'required',
          maxlength: 5000,
        },
      },
    },
    name: {
      type: 'text',
      label: '標題',
      rules: 'required',
      maxlength: 100,
    },
    attaches: {
      type: 'files',
      label: '附件',
      uploadUrl: '/announcement/attach/',
    },
    is_active: {
      type: 'switch',
      label: '',
      defaultValue: true,
      activeText: '顯示',
      inactiveText: '隱藏',
    },
    released_at: {
      type: 'datetime',
      label: '發布時間',
      rules: 'required',
      format: 'YYYY-MM-DD HH',
      disabledDate: (date) => date < new Date(new Date().setHours(0, 0, 0, 0)),
      disabledTime: (date) => date < moment().toDate(),
      defaultValue: H_time.getNextOnTheHour(),
    },
    released_admin: {
      type: 'belongsTo',
      label: '發布者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    reads: {
      type: 'text',
      label: '點擊數',
      readonly: true,
    },
    author: {
      type: 'text',
      label: '作者',
      rules: 'required',
      maxlength: 100,
    },
    authorizer: {
      type: 'text',
      label: '授權者',
      rules: 'required',
      maxlength: 100,
    },
    cover_image: {
      type: 'file',
      label: '封面圖片',
      uploadUrl: '/announcement/cover_image/',
    },
    is_released: {
      type: 'text',
      label: '發布狀態',
      readonly: true,
      getText: (value) => {
        return value === 1 ? '已發布' : '未發布';
      },
    }
  },
};
